import React, { useState } from "react";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { Facebook } from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import PlaceIcon from "@mui/icons-material/Place";
import { Images } from "../../../helpers/Images";
import "./AccreditedOrganizations.css";

const Organizations = [
  {
    photo: Images.mawaheb,
    name: "Mawaheb Academy",
    whatsapp: "https://wa.me/+201090234005",
    linkedin: "https://www.linkedin.com/company/mawaheb-academy",
    email: "",
    brief:
      "Mawaheb Academy is a dedicated STEM education academy with 10+ years of experience in Robotics, Coding, and AI, delivering high-quality training that fosters creativity and innovation.",
    location: "Suez /Cairo /Maadi /Elshorouk - Egypt",
    facebook: "https://www.facebook.com/MawahebAcademy1",
    Instagram: "https://www.instagram.com/mawahebacademy1/",
    mapLocation: "https://maps.app.goo.gl/mrLtFCCxXprrLHau6",
    Country: "Egypt",
    City: "Suez Cairo Maadi Elshrouk",
  },
  {
    photo: Images.purpose,
    name: "Purpose Academy",
    whatsapp: "https://wa.me/+970594958002",
    linkedin: "https://www.linkedin.com/company/purposeedu/",
    email: "info@purpose.ps",
    brief:
      "Purpose is an AI & robotics training provider. Our goal is to train talent in Palestine and worldwide in preparation for the fourth industrial revolution and the AI future.",
    location: "Ramallah - Plastine",
    facebook: "https://www.facebook.com/PurposeEdu",
    Instagram: "https://www.instagram.com/purpose_edu",
    website: "",
    mapLocation: "",
    Country: "Plastine",
    City: "Ramallah",
  },
  {
    photo: Images.techware,
    name: "Techware Academy",
    whatsapp: "https://wa.me/+201010179604",
    linkedin: "https://www.linkedin.com/company/techware-academy/",
    email: "techwareacademy@gmail.com",
    brief:
      "Techware Academy, founded in 2018, is a leading STEM education center in 10th of Ramadan, offering robotics, coding, electronics, and web design courses for students aged 4-18, fostering innovation and global competitiveness.",
    location: "Sharqiya",
    facebook: "https://www.facebook.com/techware.academy/",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/k5rGgaVjzkLsLFHG8",
    Country: "Egypt",
    City: "Sharqiya",
  },
  {
    photo: Images.logic,
    name: "Logic Club",
    whatsapp: "https://wa.me/+201000108161",
    linkedin: "https://www.linkedin.com/company/37503774",
    email: "logiclub.egypt@gmail.com",
    brief:
      "Logic Club, founded in 2011, teaches kids technology through robotics, coding, and electronics, fostering creativity, problem-solving, teamwork, and critical thinking while emphasizing moral values and character development.",
    location: "Cairo",
    facebook: "https://www.facebook.com/LogiClub",
    Instagram: "",
    mapLocation: "https://goo.gl/maps/EgHEh3TrDAsRPN579",
    Country: "Egypt",
    City: "Cairo",
  },
  {
    photo: Images.tamayoz,
    name: "TAMAYOZ Academy ",
    whatsapp: "https://wa.me/+201500987687",
    linkedin: "",
    email: "tamayoz.academy00@gmail.com",
    brief:
      "Ready to take your child's education to the next level? ✨\n Our robotics course provides a fun and engaging learning environment. Discover the benefits of STEM education today with TAMAYOZ Academy ❤️",
    location: "Cairo",
    facebook: "https://www.facebook.com/share/1B3QLopQ2K/",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/JrvmT82Vew4d9pwo8 ",
    Country: "Egypt",
    City: "Cairo",
  },
  {
    photo: Images.mindCraft,
    name: "Mind Craft Academy",
    whatsapp: "https://wa.me/+201155490240",
    linkedin: "",
    email: "mindcraft433@gmail.com",
    brief:
      "MIND CRAFT Academy is a dedicated STEM education organization with 4+ years of experience in Robotics, Coding, and AI, delivering high-quality trainings for students aged from 6-16 years.\nCertified from stem.org and Arab robotics and AI Association \n\nLocation: El Mahalla El kubra - Egypt\n\n\n",
    location: "Gharbiya",
    facebook:
      "https://www.facebook.com/profile.php?id=100089128407841&mibextid=ZbWKwL",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/QadQq7E8ER12fYTQA",
    Country: "Egypt",
    City: "Gharbiya",
  },
  {
    photo: Images.light,
    name: "Light Academy",
    whatsapp: "https://wa.me/+201005082653",
    linkedin: "https://www.linkedin.com/in/light-academy-4688a32b4",
    email: "lightstemaccreditation990@gmail.com",
    brief:
      "Light Academy is dedicated STEM education organization with 1+ years of experience in Robotics, Coding, and AI,UC math, delivering high-quality trainings for students aged from 6-16 years.\nLocation: Menof/Menofia - Egypt\n",
    location: "Menufiya",
    facebook: "https://www.facebook.com/share/1E28uwCz3U/",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/kY2UQb44BeQFr74X8?g_st=iwb",
    Country: "Egypt",
    City: "Menufiya",
  },
  {
    photo: Images.little,
    name: "Little Coder Academy",
    whatsapp: "https://wa.me/+201124872494",
    linkedin: "https://www.linkedin.com/in/little-coder-academy-890237294/",
    email: "little.coder.ac@gmail.com",
    brief:
      "Little Coder Academy is a dedicated STEM education organization with 8+ years of experience in Robotics, Coding, and AI, delivering high-quality trainings for students aged from 6-16 years.\nLocation: Giza/Beni-suef - Egypt",
    location: "Beni Suef",
    facebook: "https://www.facebook.com/littlecoderacademy",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/DpgCcMguUVqREz978",
    Country: "Egypt",
    City: "Beni Suef",
  },
  {
    photo: Images.inventa,
    name: "INVENTA",
    whatsapp: "https://wa.me/+201040737208",
    linkedin: "",
    email: "academyinventa@gmail.com",
    brief:
      "Inventa Academy, we empower young minds through Robotics, Coding, and AI, turning kids into real-life inventors! Our expert-led courses provide hands-on experience, problem-solving skills, and creativity for students aged 6 to 17.\nLocation: Alexandria - Egypt ",
    location: "Alexandria",
    facebook: "https://www.facebook.com/share/165bH73xdo/",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/E7KCX1hWwj2xDQuG7",
    Country: "Egypt",
    City: "Alexandria",
  },
  {
    photo: Images.technology,
    name: "Technology Leaders Academy",
    whatsapp: "https://wa.me/+01012500134",
    linkedin: "",
    email: "mr.eslam.h.elmogy@gmail.com",
    brief:
      "Technology Leaders Academy 11+ years of experience is a STEM education center teaching kids (4-18) electronics, programming, and robotics, Coding, and AI. It trains students for national and international competitions, fostering innovation and hands-on learning.\nLocations: shikh-zayed/6-october/nasr-city/elmohandseen/elfardos",
    location: "Cairo",
    facebook: "https://www.facebook.com/TechnologyLeadersZayed/",
    Instagram: "",
    mapLocation: "https://www.google.com/maps?q=30.0406238,31.0108664",
    Country: "Egypt",
    City: "Cairo",
  },
  {
    photo: Images.willy,
    name: "Willy Robotics Academy",
    whatsapp: "https://wa.me/+201007368867",
    linkedin: "",
    email: "janarafat18@gmail.com",
    brief:
      "Willy Robotics Academy is dedicated STEM education organisation with +5 years of experience in Robotics and ,Coding and AI ,delivering high quality trainings for students aged from 6-18 years. \nLocation: 285 L Pyramids garden-Giza.",
    location: "Giza",
    facebook: "https://www.facebook.com/share/19z5Z64Nip/",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/rUXjoLRZCEDCDocR9",
    Country: "Egypt",
    City: "Giza",
  },
  {
    photo: Images.innovation,
    name: "Innovation-hub",
    whatsapp: "https://wa.me/+201124338883",
    linkedin: "",
    email: "eng.hader2012@gmail.com",
    brief:
      "Innovation-hub focuses on training kids in programming and robotics using a STEM-based approach. It equips young learners with technical skills, problem-solving abilities, and creativity through hands-on experiences, fostering innovation and future-ready skills.",
    location: "Cairo",
    facebook: "https://www.facebook.com/share/1A6z5DmAky/?mibextid=wwXIfr",
    Instagram: "",
    mapLocation: "",
    website: "https://innovation-hub.app/",
    Country: "Egypt",
    City: "Cairo",
  },
  {
    photo: Images.innova,
    name: "Innova STEM Education",
    whatsapp: "https://wa.me/+201060867751",
    linkedin: "https://www.linkedin.com/company/innovastemedu/",
    email: "omarkhaled2k3@gmail.com",
    brief:
      "Innova STEM Education is a leading STEM academy with 10+ years of experience in programming and robotics, offering courses in AI, web development, Java, Python, app development, game development, and more for students aged 6-18. Our students excel in national and international competitions.\nLocation: Alexandria, Egypt",
    location: "Alexandria",
    facebook: "https://www.facebook.com/INNOVA.STEM.edu",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/ZcJ1moaqSBLu3ziJA",
    Country: "Egypt",
    City: "Alexandria",
  },
  {
    photo: Images.lc,
    name: "I.C Robotics Academy",
    whatsapp: "https://wa.me/+201124032424",
    linkedin: "https://www.linkedin.com/company/ic-robotics-academy/",
    email: "eng.amr.saadawi@gmail.com",
    brief:
      "أكاديمية الروبوت والبرمجة I.C Robotics Academy الرائدة في التعليم والتصنيع التكنولوجي بمدينة المنصورة منذ عام ٢٠١٧\n\nتسعى الأكاديمية دائمًا لتأهيل الأطفال والشباب من سن 5 إلى 17 سنة من خلال برامج STEAM المتكاملة..\n",
    location: "Dakhaliya",
    facebook: "https://www.facebook.com/share/194Kt8XZMz/?mibextid=wwXIfr",
    Instagram: "",
    mapLocation:
      "https://maps.app.goo.gl/hhVH8nc6o65eFqC88?g_st=com.google.maps.preview.copy",
    Country: "Egypt",
    City: "Dakhaliya",
  },
  {
    photo: Images.land,
    name: "Tricksland Steam Academy",
    whatsapp: "https://wa.me/+201113723845",
    linkedin: "https://www.linkedin.com/in/alaa-ahmed-8996ab19a",
    email: "alaafcieng@gmail.com",
    brief:
      "🌟What is Tricks Land ?\nTricks land is the First Biggest Kids-Land To Unlock the Future 🌏✨\nTricksLand Training Students aged 4 to 16 years old \nOn Robotics 🦾🤖 , Programming, Electronics \nin Bani-Suef government \n\n🌟Founded by: Steam Academy 2017\n\n🌟Our Vision:\nLearning is a journey and powerful weapon which you can use to change the world 🌎 \n",
    location: "Beni Suef",
    facebook: "https://www.facebook.com/share/1DaECpKRAn/?mibextid=wwXIfr",
    Instagram: "",
    mapLocation:
      "https://maps.app.goo.gl/BcKcDCU7G9eWyUQz8?g_st=com.google.maps.preview.copy",
    Country: "Egypt",
    City: "Beni Suef",
  },
  {
    photo: Images.techno,
    name: "Techno Genius",
    whatsapp: "https://wa.me/+201044329178",
    linkedin: "",
    email: "samermohammed941@gmail.com",
    brief:
      "TechnoGenius Academy is an educational institution specializing in technology and innovation. Their curriculum includes courses on robotics, automation, artificial intelligence, electronics and circuit design, and the Internet of Things (IoT). The academy aims to prepare future generations by equipping them with essential skills in these cutting-edge fields. ",
    location: "Dakhaliya",
    facebook: "https://www.facebook.com/share/18gTWebLvb/",
    Instagram: "",
    mapLocation: "https://maps.app.goo.gl/Abyuqktms3bn5meU6?g_st=ac",
    Country: "Egypt",
    City: "Dakhaliya",
  },
  {
    photo: Images.kids,
    name: "Science Kids",
    whatsapp: "https://wa.me/+201111649609",
    linkedin: "",
    email: "aya.hesham602.th6@gmail.com",
    brief:
      "Science Kids is a dedicated STEM education organization with 3+ years of experience in Robotics, Coding, and AI, delivering high-quality trainings (online and offline)for students aged from 5-16 years.\nLocation:Mit Ghamr, Dakhliya,Egypt ",
    location: "Dakhaliya",
    facebook: "https://www.facebook.com/ScienceClubMG",
    Instagram: "",
    mapLocation: "https://maps.google.com/?q=30.724319,31.258963",
    Country: "Egypt",
    City: "Dakhaliya",
  },
  {
    photo: Images.sts,
    name: "Smart Techno Students",
    whatsapp: "https://wa.me/+201204633338",
    linkedin: "",
    email: "eman.stseg@gmail.com",
    brief:
      "STS Academy is a dedicated STEM education organization with 10+ years of experience in Robotics, Coding, and AI, delivering high-quality trainings for students aged from 4-20 years.\nLocation: Obour city cairo Egypt ",
    location: "Cairo",
    facebook: "https://www.facebook.com/share/1ERNbNtHuX/?mibextid=wwXIfr",
    Instagram: "",
    mapLocation:
      "https://maps.app.goo.gl/f6aC1x43TzqgDQwq7?g_st=com.google.maps.preview.copy",
    Country: "Egypt",
    City: "Cairo",
  },
  {
    photo: Images.child,
    name: "Child Home Robotics Academy ",
    whatsapp: "https://wa.me/+201065402123",
    linkedin: "",
    email: "child.home.robotics@gmail.com",
    brief:
      "Child Home Robotics Academy with 9+ years of experience empowering young minds with the skills they need to succeed in the digital age. Our engaging, hands-on coding programs turn screen time into productive learning—helping children develop critical thinking, creativity, and problem-solving skills.",
    location: "Qena",
    facebook: "https://www.facebook.com/share/1DC4CESk7C/",
    Instagram: "",
    mapLocation: "https://goo.gl/maps/TcQQE9xcTLAivdaK8",
    Country: "Egypt",
    City: "Qena",
  },
  {
    email: "kady115@gmail.com",
    name: "Little Engineer Center",
    photo: Images.LittleEng,
    City: "Menia",
    mapLocation: "https://maps.app.goo.gl/RhbShcFWGmgNQzWN8",
    facebook:
      "https://www.facebook.com/p/Little-Engineer-Center-100064008758640/",
    linkedin: "",
    whatsapp: "https://wa.me/+201116860427",
    brief:
      "LEC aims to invest in young minds and enable them to unleash their full potential in\nSTEM (Science, Technology, Engineering and Math) concepts, through proven\nhands-on/minds on learning workshops and courses. We aspire to bridge the gap\nbetween theory and practice, between schools and universities. Moreover, we\nstrive to cultivate today's talents and mold them into future pioneers to be ready for\nthe fourth industrial revolution.",
    Country: "Egypt",
    location: "Menia",
  },
  {
    email: "gharieb.mhmd@gmail.com",
    name: "Genius Coder",
    photo: Images.GenuisCoder,
    City: "Suez",
    mapLocation: "https://maps.app.goo.gl/p5x3v9pG7Nb1gNvB8",
    facebook: "https://www.facebook.com/profile.php?id=61558672749350",
    linkedin: "https://www.linkedin.com/in/ghariebaref/",
    whatsapp: "https://wa.me/+201000599813",
    brief:
      "Genius Coder Academy is a engineering and programming  organization with 3+ years of experience in Robotics, Coding, and AI , delivering high quality trainings for students from 8 to 16 years\nLocation : Suez - Egypt",
    Country: "Egypt",
    location: "Suez",
  },
  {
    email: "noraelsayed154@gmail.com",
    name: "Code Engineers",
    photo: Images.codeEng,
    City: "Fayoum",
    mapLocation: "https://maps.app.goo.gl/h94KZydfDevAomZN9",
    facebook:
      "https://www.facebook.com/profile.php?id=100092747031790&mibextid=ZbWKwL",
    linkedin: "",
    whatsapp: "https://wa.me/+201098697052",
    brief:
      "Code Engineers is an academy for teaching programming for children and adults (5-24) ages is organized with 2+ years of experience in coding , Ai , WebDevelopment Diploma ",
    Country: "Egypt",
    location: "Fayoum",
  },
  {
    email: "sherifelnaggar82@gmail.com",
    name: "Future Minds",
    photo: Images.FutureMinds,
    City: "Giza",
    mapLocation: "https://maps.app.goo.gl/1F54i3LdX747sSXa7",
    facebook: "https://www.facebook.com/FUTUREMINDS.tech/",
    linkedin: "",
    whatsapp: "https://wa.me/+201002410664",
    brief:
      "Future Minds is a Training Organization that teach students ages from 10 to 16 a variety of coding & programing courses as Game Design with Scratch, Application Development with Python, Web Development with JavaScript, Build and Design Robots with Arduino.",
    Country: "Egypt",
    location: "Giza",
  },
  {
    email: "emoelbediwy@gmail.com",
    name: "SCOPO Academy Elmahala branch ",
    photo: Images.Scopo,
    City: "Gharbiya",
    mapLocation: "https://maps.app.goo.gl/bU9gC9Tyiv436yNs6",
    facebook: "Scopo ",
    linkedin: "https://www.facebook.com/share/1Y1KvcLViM/",
    whatsapp: "https://wa.me/+201008705804",
    brief:
      "Scopo Academy is an educational academy started at 2018 introduced  creative coding and programming courses for kids and teenagers from 5 to 18 years old. \nLocation: elmahala elkobra- elgharbia/ Egypt ",
    Country: "Egypt",
    location: "Gharbiya",
  },
  {
    email: "emoelbediwy@gmail.com",
    name: "SCOPO Academy Elmostakbal branch ",
    photo: Images.Scopo,
    City: "Cairo",
    mapLocation: "https://g.co/kgs/zyC4a2a",
    facebook: "SCOPO ",
    linkedin: "https://www.facebook.com/share/1Y1KvcLViM/",
    whatsapp: "https://wa.me/+201008705804",
    brief:
      "Scopo Academy is an educational academy started at 2018 introduced  creative coding and programming courses for kids and teenagers from 5 to 18 years old. \nLocation: elmahala elkobra- elgharbia/ Egypt",
    Country: "Egypt",
    location: "Cairo",
  },
  {
    email: "ahmedeldeep382@gmail.com",
    name: "Mega Robotics Academy ",
    photo: Images.MegaRobotics,
    City: "Red Sea",
    mapLocation: "https://maps.app.goo.gl/vwUxHEFdrJbggQ8k7",
    facebook: "https://www.facebook.com/share/164egQu2Ce/",
    linkedin: "https://www.linkedin.com/company/mega-robotics-academy/",
    whatsapp: "https://wa.me/+201553388338",
    brief:
      "Mega Robotics Academy is a education organization with 7+ years in coding , web design and development, AI and Robotics \nLocations: \nRed sea -Hurghada - eldahar square\nRed sea -Hurghada -magawish\nRed sea -ras ghareb \nRed sea- safaga\nSoon in Luxor\n",
    Country: "Egypt",
    location: "Red Sea",
  },
  {
    email: "mohamedzalabia443@gmail.com",
    name: "The little programmer academy ",
    photo: Images.LittlePro,
    City: "Menufiya",
    mapLocation: "https://goo.gl/maps/daVwXqUNCdccJHp89?g_st=aw",
    facebook: "https://www.facebook.com/share/16BBWsVT7n/",
    linkedin: "",
    whatsapp: "https://wa.me/+201023714324",
    brief:
      "The little programmer Academy is a dedicated STEM education organization with 3+ years of experience in Robotics, Coding, and AI, delivering high-quality trainings for students aged from up to 5 years.",
    Country: "Egypt",
    location: "Menufiya",
  },
  {
    email: "asmaaelleithy9@gmail.com",
    name: "Robonest Academy ",
    photo: Images.Robonest,
    City: "Menia",
    mapLocation: "Online",
    facebook: "https://www.facebook.com/share/18eT3ReAJV/",
    linkedin: "",
    whatsapp: "https://wa.me/+201018392493",
    brief:
      "Robonest Academy offers professional programming , robotics and Ai courses for children aged 4-16 ,Using STEAM education to    foster creativity, critical thinking , and hands on learning in a fun , engaging environment.\nLocation:Menial/New Menia /Online",
    Country: "Egypt",
    location: "Menia",
  },
  {
    email: "hmmaa1235@gmail.com",
    name: "MegaMinds Academy Fayoum",
    photo: Images.MegaMinds,
    City: "Fayoum",
    mapLocation:
      "https://maps.app.goo.gl/87jYvd56YMfGjq147?g_st=com.google.maps.preview.copy",
    facebook: "https://www.facebook.com/share/1Aki3HTNXX/?mibextid=wwXIfr",
    linkedin: "",
    whatsapp: "https://wa.me/+201024816900",
    brief:
      "MegaMinds Academy in Fayoum empowers K-16 youth through STEM programs that boost college readiness and hands-on learning. Students gain structural design and programming skills by building and coding robots using LEGO tools. With 3 years of experience, they solve real-world challenges and compete internationally in the Robot Challenge, focusing on solutions that support the UN Sustainable Development Goals.",
    Country: "Egypt",
    location: "Fayoum",
  },
  {
    email: "apexluxor@gmail.com",
    name: "Apex",
    photo: Images.apex,
    City: "Luxor",
    mapLocation: "https://maps.app.goo.gl/K3MrTZNnEhztyAEn9",
    facebook: "https://www.facebook.com/apexcodingacad",
    linkedin: "",
    whatsapp: "https://wa.me/+201002184695",
    brief:
      "Apex is an Egyptian Ed Tech company that provides specialized one to\none programming and computer science courses in Arabic for kids aged\n6 to 15 years old through special digital platform. Apex is a dedicated STEM education organization with 8+ years of experience in teaching computer science and AI.",
    Country: "Egypt",
    location: "Luxor",
  },
  {
    email: "technomind2026@gmail.com",
    name: "Techno Mind Academy",
    photo: Images.technoMind,
    City: "Alexandria",
    mapLocation: "https://maps.app.goo.gl/KbWR3K1ApixKg3Ls6?g_st=awb",
    facebook: "https://www.facebook.com/share/1FAzoiCqTv/",
    linkedin: "https://www.linkedin.com/company/techno-mind-academy",
    whatsapp: "https://wa.me/+201112358939",
    brief:
      "Techno Mind Academy Academy is a dedicated STEM education organization with 4+ years of experience in Robotics, Coding, AI, Graphic , motion Graphic and montage  delivering high-quality trainings for students aged from 5-18 years. Location: Alexandria - Egypt",
    Country: "Egypt",
    location: "Alexandria",
  },
];

const AccreditedOrganizations = ({
  title = "Meet Our Accredited Organizations",
}) => {
  const [countryF, setCountryF] = useState("All");
  const [cityF, setCityF] = useState("All");

  const handleCountry = (event) => {
    setCountryF(event.target.value);
    setCityF("All");
  };

  const handleCity = (event) => {
    setCityF(event.target.value);
  };

  return (
    <>
      <Typography
        id={"part"}
        variant={"h1"}
        sx={{
          textAlign: "center",
          fontSize: { xs: "22px", sm: "35px" },
          fontWeight: "500",
          color: "primary.darker",
          marginTop: "40px",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          height: "3px",
          width: { xs: "150px", sm: "300px" },
          backgroundColor: "primary.light",
          margin: "5px auto 30px",
        }}
      />
      <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
        <FormControl fullWidth sx={{ maxWidth: "250px", mx: 1 }}>
          <InputLabel>Country</InputLabel>
          <Select value={countryF} label="Country" onChange={handleCountry}>
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"Egypt"}>Egypt</MenuItem>
            <MenuItem value={"Plastine"}>Plastine</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ maxWidth: "250px", mx: 1 }}>
          <InputLabel>City</InputLabel>
          <Select value={cityF} label="Country" onChange={handleCity}>
            <MenuItem value={"All"}>All</MenuItem>

            {countryF == "Egypt" &&
              [
                "Cairo",
                "Maadi",
                "Elshrouk",
                "Giza",
                "Alexandria",
                "Suez",
                "Dakhaliya",
                "Qena",
                "Menufiya",
                "Sharqiya",
                "Gharbiya",
                "Beni Suef",
                "Menia",
                "Fayoum",
                "Luxor",
                "Red Sea",
              ]?.map((cit) => <MenuItem value={cit}>{cit}</MenuItem>)}

            {countryF == "Plastine" &&
              ["Ramallah"]?.map((cit) => (
                <MenuItem value={cit}>{cit}</MenuItem>
              ))}

            {countryF == "All" ? (
              <MenuItem disabled>Choose Country first</MenuItem>
            ) : (
              ""
            )}
          </Select>
        </FormControl>
      </Box>
      <Grid
        container
        rowSpacing={{ xs: 4, md: 6 }}
        columnSpacing={{ xs: 2, md: 4 }}
      >
        {Organizations?.filter(
          (org) => org?.Country.includes(countryF) || countryF == "All"
        )
          ?.filter((org) => org?.City.includes(cityF) || cityF == "All")
          ?.map((item) => (
            <Grid item xs={6} md={3}>
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                  height: { xs: "150px", md: "200px" },
                  backgroundSize: "70%",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundImage: `url("${item?.photo}")`,
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    opacity: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: "10px",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    "&:hover": {
                      opacity: "1",
                    },
                  }}
                >
                  <Typography
                    variant={"p"}
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "9px", sm: "12px" },
                      fontWeight: "500",
                      color: "White",
                      marginTop: "10px",
                    }}
                  >
                    {item?.brief}
                  </Typography>
                  <Typography
                    variant={"p"}
                    sx={{
                      textAlign: "center",
                      fontSize: { xs: "10px", sm: "14px" },
                      fontWeight: "500",
                      color: "White",
                      marginTop: "10px",
                    }}
                  >
                    Location: {item?.location}
                  </Typography>
                </Box>
              </Box>
              <Typography
                variant={"h4"}
                sx={{
                  textAlign: "center",
                  fontSize: { xs: "16px", sm: "22px" },
                  fontWeight: "500",
                  color: "primary.darker",
                  marginTop: "10px",
                }}
              >
                {item?.name}
              </Typography>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex !important",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: { xs: "0 auto", md: "5px auto 0" },
                }}
              >
                {item?.facebook ? (
                  <a
                    target="_blank"
                    href={item?.facebook}
                    className="accIcon"
                  >
                    <Facebook className="accInsideIcon" />
                  </a>
                ) : (
                  ""
                )}
                {item?.whatsapp ? (
                  <a
                    target="_blank"
                    href={item?.whatsapp}
                    className="accIcon"
                  >
                    <WhatsAppIcon className="accInsideIcon" />
                  </a>
                ) : (
                  ""
                )}
                {item?.linkedin ? (
                  <a
                    target="_blank"
                    href={item?.linkedin}
                    className="accIcon"
                  >
                    <LinkedInIcon className="accInsideIcon" />
                  </a>
                ) : (
                  ""
                )}
                {item?.instagram ? (
                  <a
                    target="_blank"
                    href={item?.instagram}
                    className="accIcon"
                  >
                    <InstagramIcon className="accInsideIcon" />
                  </a>
                ) : (
                  ""
                )}
                {item?.mapLocation ? (
                  <a
                    href={item?.mapLocation}
                    target="_blank"
                    className="accIcon"
                    style={{ margin: "0" }}
                  >
                    <PlaceIcon className="accInsideIcon" />
                  </a>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          ))}
      </Grid>
    </>
  );
};

export default AccreditedOrganizations;
